{
  "#TICKETS/PUBLIC": {
    "APP": "Tickets",
    "TICKET_ACCOUNT_CONTEXT": "Angezeigte Firmen (für das Ticketportal)",
    "SELECT_ALL": "Alle Auswählen",
    "SELECT_NONE": "Alle Abwählen"
  },
  "#TICKETS": {
    "TITLE": "Tickets",
    "FILTER": "Alle",
    "MENU": {
      "OVERVIEW": "Ticketübersicht",
      "CREATE": "Ticket erfassen",
      "SEARCH": "Suchen"
    },
    "ACTIONS": {
      "TICKET": "Ticket",
      "EXPORT": "Exportieren",
      "NEXT_STEP": {
        "TITLE": "Status setzen",
        "SUCCESS": "Der Status wurde erfolgreich gesetzt",
        "FAILURE": "Der Status konnte nicht gesetzt werden"
      },
      "CLOSE": {
        "TITLE": "Ticket beenden",
        "QUESTION": "Möchten sie dieses Ticket wirklich beenden?",
        "SUCCESS": "Das Ticket wurde beendet",
        "FAILURE": "Das Ticket konnte nicht beendet werden"
      },
      "RESET": {
        "TITLE": "Ticket zurücksetzen",
        "QUESTION": "Möchten sie dieses Ticket wirklich zurücksetzen?",
        "SUCCESS": "Das Ticket wurde zurückgesetzt",
        "FAILURE": "Das Ticket konnte nicht zurückgesetzt werden"
      },
      "EDIT_TICKET": "Bearbeiten",
      "ADD_COMMENT": "Kommentar hinzufügen",
      "UPLOAD_DOCUMENT": "Dokumente hochladen",
      "EDIT_CONTACTS": "Teilnehmer ändern",
      "EDIT_TIME_REPORT": "Arbeitszeiterfassung",
      "CHECK_LIST": "Checkliste",
      "ASSIGN_TICKET": "Übernehmen / Zuweisen"
    },
    "STATES": {
      "NEW": "Neu",
      "OPEN": "Offen",
      "RELEASED": "Freigabe",
      "COMPLETED": "Erledigt"
    },
    "OVERVIEW": {
      "TITLE": "Ticketübersicht",
      "SEARCH": "Nach Ticket-ID oder Name suchen",
      "APPLIED_FILTERS": "Angewendete Filter:",
      "TICKET": "Ticket",
      "CREATED": "Erstellt am ",
      "ERROR_NOT_FOUND": "Das Ticket mit der Id {{id}} konnte nicht gefunden werden!",
      "MORE_TICKETS": "weitere {{count}} Tickets vorhanden"
    },
    "CREATE": {
      "TITLE": "Ticket erstellen",
      "NAME": "Bezeichnung",
      "TYPE": "Typ",
      "DESCRIPTION": "Beschreibung",
      "PRIORITY": "Priorität",
      "PRIORITY_HINT": "1 = höchste, 9 = niedrigste",
      "HOTLINE": "Hotline",
      "DOCUMENTS": "Dokumente",
      "SUBMIT": "Ticket Anlegen",
      "CONTACTS": "Teilnehmer",
      "ADD_CONTACTS": "Teilnehmer hinzufügen / ändern"
    },
    "SEARCH": {
      "TITLE": "Ticketsuche",
      "NUMBER": "Ticketnummer",
      "NAME": "Bezeichnung",
      "FILTER": "Filter",
      "FROM": "Von Datum",
      "TO": "Bis Datum",
      "FROM_PRIORITY": "Von Priorität",
      "TO_PRIORITY": "Bis Priorität",
      "RESET": "Zurücksetzen",
      "SUBMIT": "Tickets suchen"
    },
    "DETAILS": {
      "TICKET": "Ticket",
      "HEADER": {
        "CONTACTS": "Teilnehmer",
        "DESCRIPTION": "Beschreibung",
        "COMMENTS": "Kommentare",
        "DOCUMENTS": "Dokumente",
        "OBSERVERS": "Beobachter",
        "CONFIRMATION": "Bestätigung erforderlich",
        "RELEASE": "Release",
        "ANALYSE": "Analyse",
        "RELEASE_INFO": "Release-Info"
      },
      "CONFIRMATION": {
        "ORDER_1": "Der Aufwand für die Erledigung Ihres Wunsches beträgt {{time}} verrechenbare Stunden",
        "ORDER_AT_COST": "Die Verrechnung Ihres Wunsches erfolgt nach tatsächlichem Aufwand",
        "ORDER_2": "Wir bitten um Bestätigung:",
        "TEST_1": "Ihr Ticket ist zum Test freigegeben.",
        "TEST_2": "Im Fall von Problemen fügen Sie dem Ticket bitte einen Kommentar und evtl. Screenshots hinzu.",
        "SCHEDULE_1": "Für Ihr Release wurden Installationstermine vorgeschlagen (siehe Abschnitt Release).",
        "SCHEDULE_2": "Wir bitten um Bestätigung der Termine:",
        "DEFAULT": "Wir bitten um Ihre Rückmeldung:"
      },
      "STATE": "Ticket Status",
      "WORKFLOW_STATE": "Workflow Status",
      "TYPE": "Tickettyp",
      "PRIORITY": "Priorität",
      "CONTACT": "Ansprechpartner",
      "SLA": "SLA",
      "DUE": "Zu erledigen bis",
      "CREATORS": "Ersteller",
      "OBJECT": "Objekt",
      "COST_CENTER": "Kostenstelle",
      "CREATED": "Erstellt",
      "ESTIMATED_TIME": "Stundenschätzung",
      "INTERNAL": "Intern"
    },
    "DIALOGS": {
      "EDIT_ERROR_MSG": "Es ist ein Fehler aufgetreten.",
      "TIME_REPORT": {
        "TITLE": "Arbeitszeiterfassung",
        "DATE": "Datum",
        "DURATION": "Arbeitszeit (Dauer)",
        "ACTIONS": "Aktionen",
        "NO_DATA": "Es sind keine Einträge vorhanden",
        "ADD": "Hinzufügen",
        "PERSONAL": "Benutzer",
        "CREATE": {
          "TITLE": "Arbeitszeit erfassen",
          "SUBMIT": "Erfassen",
          "SUCCESS": "Die Arbeitszeit wurde erfasst",
          "FAILURE": "Beim erfassen der Arbeitszeit ist ein Fehler aufgetreten"
        },
        "UPDATE": {
          "TITLE": "Arbeitszeit ändern",
          "SUBMIT": "Ändern",
          "SUCCESS": "Die Arbeitszeit wurde geändert",
          "FAILURE": "Beim ändern der Arbeitszeit ist ein Fehler aufgetreten"
        },
        "DELETE": {
          "ACTION": "Löschen",
          "TITLE": "Arbeitszeit löschen",
          "MESSAGE": "Möchten Sie den Eintrag wirklich löschen?",
          "SUBMIT": "Löschen",
          "CANCEL": "Abbrechen",
          "SUCCESS": "Die Arbeitszeit wurde gelöscht",
          "FAILURE": "Beim löschen der Arbeitszeit ist ein Fehler aufgetreten"
        }
      },
      "CHECK_LIST": {
        "TITLE": "Checkliste",
        "NO_DATA": "Es sind keine Einträge vorhanden",
        "NOTE": "Anmerkung",
        "ERROR": "Fehlertext",
        "DONE": "Erledigt",
        "ADD": "Hinzufügen",
        "NAME": "Text",
        "TYPE": "Typ",
        "CHECK_POINT_TYPE": {
          "ENTW": "Entwicklung",
          "TEST": "Test",
          "ZUT": "Zuteilen"
        },
        "VALIDATION": {
          "TEST_ERROR": "Der Test muss entweder auf \"Erledigt\" gesetzt sein oder einen Fehlertext beinhalten."
        },
        "STATE": {
          "CREATE": {
            "SUCCESS": "Der Status wurde erfasst",
            "FAILURE": "Beim erfassen des Status ist ein Fehler aufgetreten"
          },
          "UPDATE": {
            "SUCCESS": "Der Status wurde geändert",
            "FAILURE": "Beim ändern des Status ist ein Fehler aufgetreten"
          },
          "DELETE": {
            "SUCCESS": "Der Status wurde gelöscht",
            "FAILURE": "Beim löschen des Status ist ein Fehler aufgetreten"
          }
        },
        "CREATE": {
          "TITLE": "Checkpoint erstellen",
          "SUBMIT": "Speichern",
          "SUCCESS": "Der Checkpoint wurde erfasst",
          "FAILURE": "Beim erfassen des Checkpoints ist ein Fehler aufgetreten"
        },
        "UPDATE": {
          "TITLE": "Checkpoint bearbeiten",
          "SUBMIT": "Speichern",
          "SUCCESS": "Der Checkpoint wurde geändert",
          "FAILURE": "Beim ändern des Checkpoints ist ein Fehler aufgetreten"
        },
        "DELETE": {
          "ACTION": "Löschen",
          "TITLE": "Checkpoint löschen",
          "MESSAGE": "Möchten Sie den Eintrag wirklich löschen?",
          "SUBMIT": "Löschen",
          "CANCEL": "Abbrechen",
          "SUCCESS": "Der Checkpoint wurde gelöscht",
          "FAILURE": "Beim löschen des Checkpoints ist ein Fehler aufgetreten"
        }
      },
      "EXPORT_TICKET": {
        "TITLE": "Exportieren",
        "ALL": "Alle Tickets",
        "TICKET": "Ticket \"{{id}} - {{name}}\"",
        "SUBMIT": "Herunterladen"
      },
      "CANCEL": "Abbrechen",
      "SET_FILTER": {
        "TITLE": "Filter",
        "SUBMIT": "Anwenden"
      },
      "NEXT_STEP": {
        "TITLE": "Status setzen",
        "SUBMIT": "Speichern",
        "STEP": "Status",
        "CHANGE": "Ändern",
        "NO_STEPS": "Sie können den Status dieses Tickets nicht ändern"
      },
      "EDIT": {
        "TITLE": "Ticket bearbeiten",
        "SUBMIT": "Speichern",
        "OBJECT": "Objekt",
        "DUE": "Zu erledigen bis",
        "NAME": "Titel",
        "TYPE": "Typ",
        "COST_CENTER": "Kostenstelle",
        "COBIT_CATEGORY": "Cobit-Kategorie",
        "RFC_CATEGORY": "RFC-Bereich",
        "PRIORITY": "Priorität",
        "RELEASE_TEST_START": "Release Start (Testsystem)",
        "RELEASE_TEST_DURATION": "Release Dauer (Testsystem)",
        "RELEASE_ORIG_START": "Release Start (Echtsystem)",
        "RELEASE_ORIG_DURATION": "Release Dauer (Echtsystem)",
        "ERRORS": {
          "MOVE_DEADLINE_BACKWARDS": "Der Termin kann nur nach vorne veschoben werden",
          "DEADLINE_LESSER_THAN_TODAY": "Der Termin darf nur in der Zukunft liegen"
        }
      },
      "ADD_COMMENT": {
        "TITLE": "Kommentar hinzufügen",
        "COMMENT": "Kommentar",
        "INTERNAL": "Intern",
        "SUBMIT": "Speichern"
      },
      "ADD_DOCUMENT": {
        "TITLE": "Dokumente hochladen",
        "SUBMIT": "Speichern"
      },
      "EDIT_CONTACT": {
        "TITLE": "{{type}} bearbeiten",
        "CONTACT": "Teilnehmer",
        "SUBMIT": "Speichern",
        "EMAIL1": "E-Mail",
        "EMAIL2": "E-Mail 2",
        "FILTER": "Filtern",
        "NO_CONTACTS": "Es sind keine Kontakte vorhanden"
      },
      "ASSIGN_TICKET": {
        "TITLE": "Ticket übernehmen",
        "ASSIGN": "Ticket jemanden zuweisen",
        "TAKE_OVER_SUBMIT": "Übernehmen",
        "ASSIGN_SUBMIT": "Zuweisen",
        "NO_CONTACTS": "Es sind keine Kontakte vorhanden"
      }
    },
    "MESSAGES": {
      "CREATE_TICKET": {
        "SUCCESS": "Das Ticket wurde erfolgreich erstellt",
        "SUCCESS_LINK": "Zum Ticket",
        "FAILURE": "Das Ticket konnte nicht erstellt werden"
      },
      "UPDATE": {
        "SUCCESS": "Das Ticket wurde erfolgreich geändert",
        "FAILURE": "Das Ticket konnte nicht geändert werden"
      },
      "DOCUMENT_ADD": {
        "SUCCESS":  {
          "SINGULAR": "Das Dokument wurde erfolgreich hochgeladen",
          "PLURAL": "Das Dokument konne nicht hochgeladen werden"
        },
        "FAILURE": {
          "SINGULAR": "Das Dokument konne nicht hochgeladen werden",
          "PLURAL": "Die Dokumente konnen nicht hochgeladen werden"
        }
      },
      "ASSIGN_TICKET": {
        "SUCCESS": "Das Ticket wurde erfolgreich zugewiesen",
        "FAILURE": "Das Ticket konnte nicht zugewiesen werden"
      },
      "COMMENT": {
        "CREATE": {
          "SUCCESS": "Der Kommentar wurde erfolgreich erstellt",
          "FAILURE": "Der Kommentar konnte nicht erstellt werden."
        }
      },
      "GENERAL": {
        "SUCCESS_UPLOAD": "Hochladen erfolgreich",
        "ERROR_LOADING": "Beim Laden ist ein Fehler aufgetreten",
        "ERROR_GENERAL": "Etwas ist schiefgelaufen",
        "ERROR_DELETE": "Beim Löschen ist ein Fehler aufgetreten",
        "ERROR_UPLOAD": "Beim Hochladen ist ein Fehler aufgetreten",
        "ERROR_DOWNLOAD": "Beim Herunterladen ist ein Fehler aufgetreten"
      }
    },
    "QUERY": {
      "ID": "Id:",
      "NAME": "Name:",
      "FILTER": "Filter:",
      "FROM": "Von:",
      "TO": "Bis:",
      "PRIORITY": "Priorität"
    },
    "PROPERTIES": {
      "ID": "Id",
      "NAME": "Name",
      "FILTER": "Filter",
      "FROM": "Von",
      "TO": "Bis",
      "CONTACTS": "Teilnehmer"
    },
    "CONTACT_TYPES": {
      "OBSERVER": "Beobachter",
      "RESPONSIBLE": "Zuständiger",
      "CREATOR": "Aufnehmer",
      "CUSTOMER": "Kunde",
      "BLAME": "Verursacher",
      "RESOLVEDBY":  "Wird erledigt von",
      "ORDERCONFIRMEDBY": "Auftragsbestätigung",
      "RESOLVECONFIRMEDBY": "Erledigung bestätigt von",
      "TESTER":  "Tester",
      "IMPLEMENTEDBY": "Erlediger",
      "SENDER": "Absender",
      "CONTACTPERSON": "Ansprechpartner",
      "DOCUMENTEDBY": "Dokumentierer",
      "FOREIGNCONTACT": "Fremdkontakt"
    },
    "RFC_CATEGORIES": {
      "UNDEFINED": "Undefiniert",
      "DEVELOPMENT": "Entwicklung",
      "ACCOUNTING": "Fibu",
      "PRODUCT_MANAGEMENT": "Wws"
    },
    "CONTACT_SUMMARY": {
      "ONE_CONTACT": "{{firstName}} {{lastName}}",
      "TWO_CONTACTS": "{{firstName}} {{lastName}} und 1 weiterer",
      "MORE_CONTACTS": "{{firstName}} {{lastName}} und {{additional}} weitere"
    },
    "PRIORITIES": {
      "1": "Extrem hoch",
      "2": "Sehr hoch",
      "3": "Hoch",
      "4": "Mittel",
      "5": "Normal",
      "6": "Niedrig",
      "7": "Niedriger",
      "8": "Sehr niedrig",
      "9": "Extrem niedrig"
    }
  }
}
